import { ConfirmModalProvider, PromptModalProvider } from '@hive/component';
import { ProviderComposer } from '@hive/component/provider-composer';
import { ThemeProvider } from '@hive/core/components/theme-provider';
import type { createStore } from 'jotai';
import { Provider } from 'jotai';
import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

export type HiveContextProps = PropsWithChildren<{
  store?: ReturnType<typeof createStore>;
}>;

export function HiveContext(props: HiveContextProps) {
  return (
    <ProviderComposer
      contexts={useMemo(
        () =>
          [
            <Provider key="JotaiProvider" store={props.store} />,
            <ThemeProvider key="ThemeProvider" />,
            <ConfirmModalProvider key="ConfirmModalProvider" />,
            <PromptModalProvider key="PromptModalProvider" />,
          ].filter(Boolean),
        [props.store]
      )}
    >
      {props.children}
    </ProviderComposer>
  );
}
